import { render, staticRenderFns } from "./ArticlePicker.vue?vue&type=template&id=1bc411a6&scoped=true&"
import script from "./ArticlePicker.vue?vue&type=script&lang=js&"
export * from "./ArticlePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc411a6",
  null
  
)

export default component.exports